import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    table: {
      minWidth: 'max-content',
      borderSpacing: '0 0.4rem',
      borderCollapse: 'separate',
      paddingRight: '1rem',
      '& > thead > tr > th': {
        border: 'none',
        '& .MuiTypography-subtitle2': {
          fontSize: '1.2rem',
        },
        '&:first-child': {
          paddingLeft: '2rem',
        },
      },

      '& > tbody > tr > td': {
        border: 'none',

        '&:first-child': {
          minWidth: '15rem',
        },
        '&:nth-child(2)': {
          minWidth: '45rem',
        },
        '&:nth-child(3)': {
          minWidth: '25rem',
        },
        '&:nth-child(4)': {
          maxWidth: '10rem',
        },
      },
    },
  }),
)
